module.exports = __webpack_public_path__ + "static/media/received.433c1bdf.svg";